import { render } from "./_InstrutorPdf.vue?vue&type=template&id=268b3dfe&scoped=true"
import script from "./_InstrutorPdf.vue?vue&type=script&lang=ts"
export * from "./_InstrutorPdf.vue?vue&type=script&lang=ts"

import "./_InstrutorPdf.vue?vue&type=style&index=0&id=268b3dfe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-268b3dfe"

export default script